import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { BOOKINGS_BY_USER_ID } from '../graphql/queries/bookingQueries';
import { getCloudFrontImageUrl } from '../util/cloudFrontUtils';
import awsConfig from '../config/aws-config';

export const useFetchUserBookings = (userID) => {
  const { data, loading, error, refetch } = useQuery(BOOKINGS_BY_USER_ID, {
    variables: { userID },
    skip: !userID,
    fetchPolicy: 'cache-and-network',
  });

const processedStudio = useMemo(() => {
    if (!data?.bookingsByUserID) return null;
    
    const bookings = { ...data.bookingsByUserID };
    if (bookings.items && Array.isArray(bookings.items)) {
      bookings.items = bookings.items.map(booking => {
        if (!booking || !booking.Studio) return booking;

        const studioWithProcessedImages = {
          ...booking.Studio,
          processedImages: []
        };

        if (booking.Studio.images && booking.Studio.images.length > 0) {
          try {
            studioWithProcessedImages.processedImages = booking.Studio.images.map(imageKey => {
              if (!imageKey) return '';
              
              try {
                return getCloudFrontImageUrl(imageKey, { 
                  width: 1200,
                  height: 800, 
                  fit: 'cover' 
                });
              } catch (error) {
                try {
                  const cleanKey = imageKey.startsWith('public/') ? imageKey : `public/${imageKey}`;
                  return `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/${cleanKey}`;
                } catch (fallbackError) {
                  return '';
                }
              }
            });
          } catch (error) {
            studioWithProcessedImages.processedImages = [''];
          }
        }

        return {
          ...booking,
          Studio: studioWithProcessedImages,
        };
      });
    }

    return bookings;
  }, [data]);

  return {
    bookingStudioData: processedStudio,
    loading,
    error,
    refetch
  };
};